import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { webSiteUrl, myFetchPost } from "../utility";
import LoginSpinner from "../components/LoginSpinner";
import GoogleSignIn from "../components/GoogleSignIn";
import "../css/LoginScreen.css";

const LoginScreen = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [autologin, setAutoLogin] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [validated, setValidated] = useState(false);
  const [masterErrorMessage, setMasterErrorMessage] = useState("");

  const { currentUser, authSignIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser?.uid > 0) {
      navigate("/");
    }
  }, [currentUser]);

  const toggleAutoLogin = () => {
    setAutoLogin(!autologin);
  };

  const handleOnSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    } else {
      event.preventDefault();
      /*
      1. sign into dcfever
      2. get the token and then sign into firebase with signInWithCustomToken
      */
      const formData = new FormData();
      formData.append("username", username);
      formData.append("password", password);
      formData.append("autologin", autologin);
      formData.append("grant_type", "login");

      const requestOptions = {
        method: "POST",
        body: formData,
      };

      setIsSubmitting(true);
      setMasterErrorMessage('waiting');
      try {
        const data = await myFetchPost(
          `${webSiteUrl}/app/users/login.php`,
          formData,
          {
            "Content-Type": "multipart/form-data",
          }
        );
        if (data.status == "true") {
          authSignIn(data.access_token);
          setIsSubmitting(false);
          setMasterErrorMessage('');
        } else {
          throw data.error_message;
        }
      } catch (error) {
        setIsSubmitting(false);
        setMasterErrorMessage(error);
      }
    }
  };

  return (
    <div className="loginWrap">
      <h1 className="loginHeader mb-3 d-none">登入 DCFever</h1>
      <div className="mb-3" style={{width: '100%', textAlign: 'center'}}>
        <div className="facebookLoginBtn mb-3" style={{minHeight: '42px'}}>
          <GoogleSignIn />
        </div>
        <div className="facebookLoginBtn mb-3">
          <a href="https://www.dcfever.com/users/fbredirect.php">
            <i className="bi bi-facebook"></i>
            <span>以 Facebook 帳戶繼續</span>
          </a>
        </div>
        <div className="loginOrRow">
          <span>或者</span>
        </div>
      </div>
      <Form
        onSubmit={handleOnSubmit}
        className="loginForm"
        noValidate
        validated={validated}
      >
        {isSubmitting && masterErrorMessage && (
          <Form.Label className="masterError"><div>&nbsp;</div></Form.Label>
        )}
        {!isSubmitting && masterErrorMessage && (
          <Form.Label className="masterError"><div>{masterErrorMessage}</div></Form.Label>
        )}

        <Form.Group className="mb-2" controlId="formUser">
          <Form.Control
            type="text"
            placeholder="會員名稱/電郵地址"
            value={username}
            required
            onChange={(e) => {
              setUsername(e.target.value.trim());
            }}
          />
          <Form.Control.Feedback type="invalid">
            請輸入會員名稱/電郵地址
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formPassword">
          <Form.Control
            type="password"
            placeholder="密碼"
            value={password}
            autoComplete="current-password"
            required
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <Form.Control.Feedback type="invalid">
            請輸入密碼
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicCheckbox">
          <Form.Check
            type="checkbox"
            name="autologin"
            id="autologin"
            value="1"
            label="記住我"
            checked={autologin}
            onChange={(e) => {
              toggleAutoLogin();
            }}
          />
        </Form.Group>
        <Button variant="primary" type="submit" className="loginButton">
          登入
        </Button>
      </Form>
      <LoginSpinner isSubmitting={isSubmitting} />
    </div>
  );
};

export default LoginScreen;
